import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthProvider';

class LoginRoute extends React.Component {
    render() {
        return (
            <Route path={this.props.path}>
                {
                    !this.context.isLoggedIn ? (
                        this.props.children
                    ) : (
                        <Redirect to="/" />
                    )
                }
            </Route>
        );
    }
}
LoginRoute.contextType = AuthContext;
export default LoginRoute;
